import { useTranslation } from '@web_opxp/features';

import UserRank from './UserRank';

export type IAgreementPlaceholderProps = {
  picture?: string;
  privacyUrl: string;
};

export default function AgreementPlaceholder({ picture, privacyUrl }: Readonly<IAgreementPlaceholderProps>) {
  const { t } = useTranslation();

  return (
    <a href={privacyUrl} className="agreement-placeholder">
      <UserRank
        name={t('Highscore.AgreementLink')}
        picture={picture}
        ranking="-"
        score="---.---"
        active={true}
        loading={false}
      />
    </a>
  );
}
